/**
 * Copyright 2018 Ambrosus Inc.
 * Email: tech@ambrosus.com
 */
import React from 'react';
import './Footer.scss';
import SVG from 'react-svg';
import iconLogo from 'src/assets/svg/AMB-logo.svg';

const Footer = (prop: any) => {
  return (
    <footer className='Footer'>
      <div className='wrapper'>
        <div className='sub-footer'>
          <div className='copyright'>
            <p>&copy; 2019 Ambrosus Network. All rights reserved.</p>
          </div>
          <div className='logo'>
            <SVG className='SVG' wrapper='span' src={iconLogo}></SVG>
          </div>
          <div className='contact'>
            <a href='mailto:tech@ambrosus.com'>tech@ambrosus.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
